import { tv } from "tailwind-variants"

export const buttonLayoutVariants = tv({
  base: "inline-flex items-center whitespace-nowrap rounded-md transition duration-200",
  variants: {
    size: {
      xs: "h-6 gap-0.5 px-1.5 text-xs",
      sm: "h-8 gap-1 px-3 text-sm",
      md: "h-10 gap-1.5 px-5 text-sm",
      lg: "h-12 gap-2 px-6 text-md",
    },
    leftIcon: {
      true: "",
    },
    rightIcon: {
      true: "",
    },
  },
  compoundVariants: [
    { size: "xs", leftIcon: true, className: "pl-1" },
    { size: "xs", rightIcon: true, className: "pr-1" },
    { size: "sm", leftIcon: true, className: "pl-2" },
    { size: "sm", rightIcon: true, className: "pr-2" },
    { size: "md", leftIcon: true, className: "pl-3.5" },
    { size: "md", rightIcon: true, className: "pr-3.5" },
    {
      size: "lg",
      leftIcon: true,
      className: "pl-4",
    },
    {
      size: "lg",
      rightIcon: true,
      className: "pr-4",
    },
  ],
  defaultVariants: {
    size: "md",
  },
})
